import CatalogSearchBar from "./CatalogSearchBar";

export default CatalogSearchBar;



// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogSearchBar/index.js